import React from 'react'
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import LANDSCAPE from '../img/LANDSCAPE.jpg'
import {AnimationOnScroll} from 'react-animation-on-scroll'
function Landscape() {
  const location = useLocation();
    const componentRef = useRef(null);

    useEffect(() => {
        if (componentRef.current) {
            setTimeout(() => {

                componentRef.current.scrollIntoView({ behavior: "smooth" });
            }, 3000);
        }
    }, [location])
  return (
    <section ref={componentRef}>
      <div className="about">
            <h2 id="Content">Landscape</h2>
        </div>
        <div className="DispalyingImage">
        <AnimationOnScroll animateIn='slipeLeft'><img src={LANDSCAPE} alt="" className="DisImg"/></AnimationOnScroll>
        </div>
    </section>
  )
}

export default Landscape
